<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>

              <div class="vx-col w-full my-2">
                <vs-input
                  v-model="model.name"
                  name="departmanName"
                  :label="$t('Departman')"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('departmanName')"
                  >{{ errors.first("departmanName") }}</span
                >
              </div>

        <vs-button
          type="filled"
          class="float-right mb-4 mt-4"
          @click.prevent="submitForm"
          :disabled="!model.name"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    departmanName: {
      required: "لطفا عنوان دپارتمان را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "departman/createDepartman",
      updateAccount: "departman/editDepartman",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.model.id != null) {
            this.updateAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditDepartmans";
        else this.popupTitle = "CreateDepartmans";
      }
      this.$validator.reset();
    },
  },
};
</script>
